import { useIntl } from "react-intl";
import { SupportedLanguages } from "../common/controls/lang-switcher";
import type { SkillsChartSlideData } from "../data/skills-chart-data";

import en from "../data/skills-chart-data--en.json";
import ru from "../data/skills-chart-data--ru.json";

export type ILanguageSkillsChartDictionary = {
  [language in SupportedLanguages]: SkillsChartSlideData[];
};

export const SKILLS_CHART_DATA: ILanguageSkillsChartDictionary = {
  ru: ru as SkillsChartSlideData[],
  en: en as SkillsChartSlideData[],
};

const mapLocaleToLang = (locale: string): SupportedLanguages => {
  const short = locale.split("-")[0] as SupportedLanguages;
  if (short === "ru" || short === "en") return short;
  return "en";
};

export const useSkillsChartSlides = (): SkillsChartSlideData[] => {
  const { locale } = useIntl();
  const lang = mapLocaleToLang(locale);
  return SKILLS_CHART_DATA[lang];
};
